export enum SSOStatus {
    INACTIVE = '0',
    ACTIVE = '1',
    ACTIVE_ENABLED = '2',
}